import type { LabelProps } from "@hightouch/formkit";
import { Text } from "@hightouch/htui";
import type { SharedProps } from ".";

export const FKLabel = ({
  message,
  color,
  size,
  fontWeight,
}: LabelProps & SharedProps) => (
  <Text size={size} color={color} fontWeight={fontWeight}>
    {message}
  </Text>
);
